import {
  FilterMode,
  Phonogram_OrderBy,
  Phonogram,
  SortOrder,
  Phonogram_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const phonogramService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.phonogramOne({ id });
    return result.phonogramOne as Phonogram;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Phonogram_OrderBy[] | null = null,
    filter: Phonogram_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Phonogram_Filter | undefined;
    if (searchValue !== "") {
      where = {
        trackName: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.phonogramListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ trackName: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.phonogramListWithOffset
    ) as Phonogram[];
    return { list, orderBy };
  },
};
